// ======================================================================
// File Name       : LocalStorageConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const TOKEN = 'token';
export const AWS_UPLOADS = 'awsUploads'; // Step 10.0.0
// Step 12.0.0 START
export const EDIT_ACCOUNT_TYPE = 'editAccountType';
export const EDIT_ACCOUNT_VALUE = {
  INTEGRATION: 'integration',
  NORMAL: 'normal',
};
// Step 12.0.0 END
